import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=ts"

import "./PrimaryButton.vue?vue&type=style&index=0&id=8ac695f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac695f6"]])

export default __exports__